var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#EDF3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2531 6.10796C14.1873 6.04157 14.109 5.98887 14.0226 5.95291C13.9363 5.91695 13.8437 5.89844 13.7502 5.89844C13.6567 5.89844 13.5641 5.91695 13.4778 5.95291C13.3915 5.98887 13.3132 6.04157 13.2473 6.10796L7.97023 11.3921L5.75315 9.16796C5.68478 9.10192 5.60407 9.04999 5.51563 9.01513C5.42719 8.98028 5.33275 8.96319 5.23771 8.96483C5.14266 8.96648 5.04887 8.98683 4.96169 9.02472C4.87451 9.06261 4.79565 9.1173 4.7296 9.18567C4.66356 9.25404 4.61163 9.33475 4.57678 9.42319C4.54192 9.51163 4.52483 9.60606 4.52648 9.70111C4.52812 9.79615 4.54847 9.88994 4.58636 9.97712C4.62425 10.0643 4.67894 10.1432 4.74731 10.2092L7.46731 12.9292C7.53316 12.9956 7.6115 13.0483 7.69782 13.0843C7.78414 13.1202 7.87672 13.1387 7.97023 13.1387C8.06374 13.1387 8.15632 13.1202 8.24264 13.0843C8.32895 13.0483 8.4073 12.9956 8.47315 12.9292L14.2531 7.14921C14.325 7.08288 14.3824 7.00238 14.4217 6.91277C14.4609 6.82317 14.4812 6.72641 14.4812 6.62859C14.4812 6.53076 14.4609 6.434 14.4217 6.3444C14.3824 6.25479 14.325 6.17429 14.2531 6.10796Z",
    fill: "#476958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.472cb4fc83690d6219b94dd3b9bcd817.svg";
export { ForwardRef as ReactComponent };